/* 🤖 this file was generated by svg-to-ts */
export const siriusLockSimpleDuotone: {
  name: 'lock_simple_duotone';
  data: string;
} = {
  name: 'lock_simple_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M19.5 8.25h-15a.75.75 0 0 0-.75.75v10.5c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.875 7.5V4.875a4.125 4.125 0 0 1 8.25 0V7.5H19.5A1.5 1.5 0 0 1 21 9v10.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5V9a1.5 1.5 0 0 1 1.5-1.5h3.375Zm2.269-4.481a2.625 2.625 0 0 1 4.481 1.856V7.5h-5.25V4.875c0-.696.277-1.364.769-1.856ZM4.5 9v10.5h15V9h-15Z" fill="currentColor"/></svg>`
};
